import React from 'react';

import { ExternalLink } from 'lucide-react';

import { SEO } from '../components/SEO';



export default function References() {

  const resources = [

    {

      title: "Official .NET Documentation",

      description: "Microsoft's comprehensive documentation for .NET development.",

      url: "https://docs.microsoft.com/en-us/dotnet/",

      category: "Documentation"

    },

    {

      title: "C# Programming Guide",

      description: "Complete guide to the C# programming language.",

      url: "https://docs.microsoft.com/en-us/dotnet/csharp/",

      category: "Language"

    },

    {

      title: "A Tour of C#",

      description: "Interactive tutorials to learn C# concepts.",

      url: "https://docs.microsoft.com/en-us/dotnet/csharp/tour-of-csharp/",

      category: "Tutorial"

    },

    {

      title: "C# Tutorial - W3Schools",

      description: "Beginner-friendly tutorials covering C# basics.",

      url: "https://www.w3schools.com/cs/index.php",

      category: "Tutorial"

    },

    {

      title: "Learn C# - Codecademy",

      description: "Interactive C# courses for various skill levels.",

      url: "https://www.codecademy.com/learn/learn-c-sharp",

      category: "Course"

    },

    {

      title: "C# Station",

      description: "Tutorials and articles for C# developers.",

      url: "http://www.csharp-station.com/",

      category: "Tutorial"

    },

    {

      title: "C# in Depth",

      description: "Deep dive into C# features and best practices.",

      url: "https://csharpindepth.com/",

      category: "Book"

    },

    {

      title: "C# Programming Yellow Book",

      description: "Free ebook for learning C# from basics to advanced topics.",

      url: "http://www.csharpcourse.com/",

      category: "Book"

    },

    {

      title: "C# Fundamentals for Absolute Beginners",

      description: "Video series introducing C# programming.",

      url: "https://channel9.msdn.com/Series/C-Fundamentals-for-Absolute-Beginners",

      category: "Video"

    },

    {

      title: "C# Corner",

      description: "Community-driven platform with articles and tutorials.",

      url: "https://www.c-sharpcorner.com/",

      category: "Community"

    },

    {

      title: "Stack Overflow - C#",

      description: "Q&A platform for C# programming queries.",

      url: "https://stackoverflow.com/questions/tagged/c%23",

      category: "Community"

    },

    {

      title: "Microsoft Learn - C#",

      description: "Learning paths and modules for C# development.",

      url: "https://docs.microsoft.com/en-us/learn/browse/?term=C%23",

      category: "Course"

    },

    {

      title: "C# Programming Guide - TutorialsTeacher",

      description: "Comprehensive tutorials on C# programming.",

      url: "https://www.tutorialsteacher.com/csharp",

      category: "Tutorial"

    },

    {

      title: "C# Guide - GeeksforGeeks",

      description: "Articles and tutorials on C# concepts.",

      url: "https://www.geeksforgeeks.org/csharp-programming-language/",

      category: "Tutorial"

    },

    {

      title: "C# Tutorial - Programiz",

      description: "Interactive C# tutorials for beginners.",

      url: "https://www.programiz.com/csharp-programming",

      category: "Tutorial"

    },

    {

      title: "C# Programming - Pluralsight",

      description: "Courses covering various aspects of C# development.",

      url: "https://www.pluralsight.com/courses/c-sharp-fundamentals-dev",

      category: "Course"

    },

    {

      title: "C# Tutorials - Dot Net Perls",

      description: "Code examples and explanations for C# programming.",

      url: "https://www.dotnetperls.com/",

      category: "Tutorial"

    },

    {

      title: "C# Programming - Udemy",

      description: "Online courses for learning C#.",

      url: "https://www.udemy.com/topic/c-sharp/",

      category: "Course"

    },

    {

      title: "C# Programming - Coursera",

      description: "Courses and specializations in C# development.",

      url: "https://www.coursera.org/courses?query=c%23",

      category: "Course"

    },

    {

      title: "C# Programming - edX",

      description: "Online courses for C# programming.",

      url: "https://www.edx.org/learn/c-sharp",

      category: "Course"

    },

    {

      title: "C# Programming - LinkedIn Learning",

      description: "Video courses on C# development.",

      url: "https://www.linkedin.com/learning/topics/c-sharp",

      category: "Course"

    },

    {

      title: "C# Programming - Khan Academy",

      description: "Educational resources for learning C#.",

      url: "https://www.khanacademy.org/computing/computer-programming/programming",

      category: "Course"

    },

    {

      title: "C# Programming - SoloLearn",

      description: "Interactive C# tutorials and community.",

      url: "https://www.sololearn.com/Course/CSharp/",

      category: "Course"

    },

    {

      title: "C# Programming - HackerRank",

      description: "Coding challenges and tutorials in C#.",

      url: "https://www.hackerrank.com/domains/tutorials/10-days-of-csharp",

      category: "Tutorial"

    },

    {

      title: "C# Programming - LeetCode",

      description: "Coding problems and solutions in C#.",

      url: "https://leetcode.com/problemset/all/?listId=wpwgkgt",

      category: "Tutorial"

    },

    {

      title: "C# Programming - Codewars",

      description: "Coding challenges to improve C# skills.",

      url: "https://www.codewars.com/",

      category: "Tutorial"

    },

    {

      title: "C# Programming - Exercism",

      description: "Practice exercises and mentorship in C#.",

      url: "https://exercism.io/tracks/csharp",

      category: "Tutorial"

    },

    {

      title: "C# Programming - TopCoder",

      description: "Competitive programming challenges in C#.",

      url: "https://www.topcoder.com/",

      category: "Tutorial"

    },

    {

      title: "C# Programming - CodeChef",

      description: "Coding competitions and practice problems in C#.",

      url: "https://www.codechef.com/",

      category: "Tutorial"

    }

    // Add more resources...

  ];



  return (

    <>

      <SEO 

        title="References"

        description="Explore our portfolio of successful projects and client testimonials at LYFY. See how we've helped businesses transform their digital presence."

        keywords="portfolio, client projects, case studies, success stories, software development projects"

      />

      <div className="min-h-screen bg-gradient-to-br from-purple-50 to-blue-50 py-12 px-4">

        <div className="max-w-7xl mx-auto">

          <h1 className="text-4xl font-bold text-gray-900 mb-8">Learning Resources</h1>

          

          <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-6">

            {resources.map((resource, index) => (

              <div key={index} className="bg-white rounded-lg shadow-md p-6">

                <div className="flex items-start justify-between">

                  <h3 className="text-xl font-semibold text-gray-900">{resource.title}</h3>

                  <a

                    href={resource.url}

                    target="_blank"

                    rel="noopener noreferrer"

                    className="text-purple-600 hover:text-purple-700"

                  >

                    <ExternalLink className="w-5 h-5" />

                  </a>

                </div>

                <span className="inline-block px-2 py-1 text-sm text-purple-600 bg-purple-100 rounded-full mt-2">

                  {resource.category}

                </span>

                <p className="mt-3 text-gray-600">{resource.description}</p>

              </div>

            ))}

          </div>

        </div>

      </div>

    </>

  );

}
